<template>
  <div>403</div>
</template>

<script>
export default {
  name: "403"
}
</script>

<style scoped>

</style>